<template>
  <div class="my-dashboard d-print-none ">

    <div class="row align-items-center img-background-card py-5 dash-rounded-normal border shadow ">
      <div class="col-lg-3 col-6 text-center ">
        <img src="../../../../public/profile.webp" class="col-6 img-fluid"
             v-if="$store.getters['User/getProfile'].image == null"></img>
        <img v-else class="img-fluid h1  shadow rounded text-center rounded-circle profile-image"
             :src="$store.getters['User/getProfile'].image" alt="profile">
        <div class="d-print-none mt-1 text-white"> {{
            `${$store.getters['User/getProfile'].name} ${$store.getters['User/getProfile'].last_name}`
          }}
          <div class="col-12 text-white"> خوش آمدید !</div>
        </div>
      </div>


      <span class="col-lg-3 col-6 my-2 text-center ">

 <img class="img-fluid my-2 col-6" src="../../../../public/sms.webp">



        <h5 v-if="!loading" class="font-weight-bolder text-white ">{{ items['sms_remaining'] }} عدد</h5>
        <div v-else class="loader mx-auto"></div>

        <m-a :href="{name:'ModulesList'}" class="">
               <button class="btn btn-secondary radius-15 mt-2">خرید پیامک</button>
        </m-a>




      </span>

      <span class="col-lg-3 col-6 my-2 text-center ">
               <img class="img-fluid my-2 col-6" src="../../../../public/feature.webp">

        <h5 v-if="!loading" class="font-weight-bolder text-white ">{{ items['active_module'] }} فعال</h5>
        <div v-else class="loader mx-auto"></div>

                <m-a :href="{name:'ModulesList'}">
               <button class="btn btn-secondary radius-15 mt-2">ماژول جدید</button>
        </m-a>

      </span>

      <span class="col-lg-3 col-6 my-2 text-center ">
               <img class="img-fluid my-2 col-6" src="../../../../public/sub.webp">

        <h5 v-if="!loading" class="font-weight-bolder text-white ">{{ items['site_service_expire'] }} روز</h5>
        <h6 v-if="!loading" class="font-weight-bolder text-white " dir="ltr">

          {{ items['use_subscription_storage'] }}



          MB



          /

{{ Math.round(parseInt(items['storage_size'])) }}

          MB

        </h6>

        <div v-else class="loader mx-auto"></div>



          <m-a :href="{name:'ModulesList'}">
               <button class="btn btn-secondary radius-15 mt-2">تمدید اشتراک</button>
        </m-a>

      </span>

    </div>


  </div>
</template>

<script>
import WidgetWallet from "../../components/dashboard/Wallet/WidgetWallet";

export default {
  name: "DashboardHeaderWidget",
  components: {WidgetWallet},
  data() {
    return {
      items: {},
      loading: true
    }
  },
  methods: {
    async loadData() {
      let req = await this.$store.dispatch("DashboardSubscription/siteModuleStatus");
      let resource_counter = await this.$store.dispatch("DashboardResource/getResources")
      this.items = req.data.data
      this.items['storage_size'] = resource_counter.data.data.storage_size
      this.loading = false
    }
  },
  async mounted() {
    await this.loadData();
  }
}
</script>

<style scoped>
.profile-image {
  height: 60px;
  width: 75px;
  object-fit: contain;
}

.img-background-card {
  background-image: url("../../../../public/patern.png") !important;
  background: var(--primary);
}


.loader {
  width: 45px;
  height: 20px;
  background: linear-gradient(#0000 calc(1 * 100% / 6), #fff 0 calc(3 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(2 * 100% / 6), #fff 0 calc(4 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(3 * 100% / 6), #fff 0 calc(5 * 100% / 6), #0000 0);
  background-size: 10px 400%;
  background-repeat: no-repeat;
  animation: matrix 1s infinite linear;
}

@keyframes matrix {
  0% {
    background-position: 0% 100%, 50% 100%, 100% 100%
  }

  100% {
    background-position: 0% 0%, 50% 0%, 100% 0%
  }
}

</style>